var _polygon, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHoldZero = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "9.25 9.5 9.26105 9.50085 10 10.57385 10.73706 9.50085 10.75 9.5 10.74908 9.48383 13.79291 5.05688 12.55688 4.20709 10.74908 6.83588 10.75 0 9.25 0 9.24908 6.83588 7.44312 4.20709 6.20709 5.05688 9.24908 9.48383 9.25 9.5",
  fillRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 12.5,
  r: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.75,
  cy: 12.5,
  r: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 12.5,
  r: 1.5
})));
export default SvgHoldZero;